import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-b from-dark-800 to-dark-900 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="space-y-6">
            <div className="flex items-center space-x-3">
              <img
                src="https://static.readdy.ai/image/d40f812adce9746c671cc6e9152e021e/38d7bf67b43bcd5328b7bb3dcb84216d.png"
                alt="LONE TRS Logo"
                className="h-12 w-auto"
              />
            </div>
            <p className="font-inter text-white/60 text-sm leading-relaxed">
              16 years of excellence in transportation and relocation services across the West Coast.
            </p>
            <div className="flex items-center space-x-4">
              {[
                { icon: 'ri-facebook-fill', url: 'https://facebook.com', label: 'Facebook' },
                { icon: 'ri-instagram-line', url: 'https://www.instagram.com/lone_trs', label: 'Instagram' },
                { icon: 'ri-linkedin-fill', url: 'https://linkedin.com', label: 'LinkedIn' },
              ].map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="w-10 h-10 flex items-center justify-center bg-white/5 border border-white/10 rounded-lg hover:bg-electric-blue/20 hover:border-electric-blue transition-all duration-300 cursor-pointer"
                >
                  <i className={`${social.icon} text-lg text-white/70 hover:text-electric-blue w-5 h-5 flex items-center justify-center`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-orbitron text-white font-semibold mb-6 text-sm tracking-wider">QUICK LINKS</h3>
            <ul className="space-y-3">
              {[
                { label: 'Home', path: '/' },
                { label: 'Operations', path: '/operations' },
                { label: 'Credentials', path: '/proof' },
              ].map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="font-inter text-white/60 hover:text-electric-blue transition-colors duration-300 text-sm cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-orbitron text-white font-semibold mb-6 text-sm tracking-wider">SERVICES</h3>
            <ul className="space-y-3">
              {[
                'Residential Moving',
                'Commercial Moving',
                'Interstate Transport',
                'Vehicle Transport',
                'Freight Services',
              ].map((service, index) => (
                <li key={index} className="font-inter text-white/60 text-sm">
                  {service}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-orbitron text-white font-semibold mb-6 text-sm tracking-wider">CONTACT</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <i className="ri-phone-line text-electric-blue mt-1 w-5 h-5 flex items-center justify-center"></i>
                <a href="tel:+14158885336" className="font-inter text-white/60 hover:text-electric-blue transition-colors duration-300 text-sm cursor-pointer">
                  (415) 888-5336
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-mail-line text-electric-blue mt-1 w-5 h-5 flex items-center justify-center"></i>
                <a href="mailto:lonetrsllc@gmail.com" className="font-inter text-white/60 hover:text-electric-blue transition-colors duration-300 text-sm cursor-pointer">
                  lonetrsllc@gmail.com
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-electric-blue mt-1 w-5 h-5 flex items-center justify-center"></i>
                <span className="font-inter text-white/60 text-sm">
                  Las Vegas Valley, NV
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
          <p className="font-inter text-white/40 text-xs">
            © 2024 LONE TRS LLC. All rights reserved.
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="font-inter text-white/40 hover:text-electric-blue transition-colors duration-300 text-xs cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
